<!-- TIPI vers PORTAIL -->

<template>
  <div class="container">

    <section class="spread" v-if="loadingConfiguration || loadingResultPayment">
      <grid-loader :color="'rgba(0, 0, 0, .1)'"></grid-loader>
    </section>

    <section class="spread" v-else-if="networkErrorConfiguration">
      <NetworkAlert :title="'Réseau indisponible'" defaultLink='refresh'>
        <p>
          Une erreur réseau est survenue,
          <br>veuillez réessayer plus tard.
        </p>
      </NetworkAlert>
    </section>

    <section class="spread" v-else-if="networkErrorResultPayment">
      <NetworkAlert :title="'Récupération indisponible'" defaultLink='refresh'>
        <p>
          La récupération du résultat du paiement
          <br>est impossible pour le moment,
          <br>veuillez réessayer plus tard.
        </p>
      </NetworkAlert>
    </section>

    <section v-else>
      <CityInfosMessage :cityLogo="cityParameters.logo" :cityName="cityParameters.cityName" defaultLink='home'>
        <h3>Résultat du paiement</h3>
        <PaymentStatus :resultPayment="resultPayment"></PaymentStatus>
        <div class="buttons">
          <a @click.prevent="redirectToHome()">Retour à l'accueil</a>
        </div>
      </CityInfosMessage>
    </section>

  </div>
</template>

<script>
import CityParametersService from '@/services/cityParametersService'
import ResultPaymentService from '@/services/resultPaymentService'

import GridLoader from 'vue-spinner/src/GridLoader.vue'
import NetworkAlert from '@/components/NetworkAlert.vue'
import CityInfosMessage from '@/components/CityInfosMessage.vue'
import PaymentStatus from '@/components/PaymentStatus.vue'

export default {
  components: {
    GridLoader,
    NetworkAlert,
    CityInfosMessage,
    PaymentStatus
  },
  data () {
    return {
      loadingConfiguration: true,
      loadingResultPayment: true,
      networkErrorConfiguration: false,
      networkErrorResultPayment: false,
      idOp: null,
      cityParameters: {},
      resultPayment: null
    }
  },
  mounted () {
    this.retrieveParameters()

    if (this.$route.query.idop) {
      this.idOp = this.$route.query.idop
      this.retrieveResultPayment()
    } else {
      this.redirectToHome()
    }
  },
  methods: {
    retrieveParameters () {
      new CityParametersService()
        .retrieveParameters()
        .then(data => {
          this.cityParameters = data
        })
        .catch(error => {
          console.log(error)
          this.networkErrorConfiguration = true
        })
        .finally(() => {
          this.loadingConfiguration = false
        })
    },
    retrieveResultPayment () {
      new ResultPaymentService()
        .retrieveMessage(this.idOp)
        .then(data => {
          this.resultPayment = data
        })
        .catch(error => {
          console.log(error)
          this.networkErrorResultPayment = true
        })
        .finally(() => {
          this.loadingResultPayment = false
        })
    },
    redirectToHome () {
      if (this.$route.params.tenantCode) {
        this.$router.push('/' + this.$route.params.tenantCode)
      } else {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
.infos {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 500px;
}

.infos .buttons {
  margin-top: 1rem;
}

@media (max-width: 1000px) {
  .infos {
    width: auto;
  }
}

/* IE10+ CSS styles */
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
}
</style>



// WEBPACK FOOTER //
// src/views/Result.vue